const secondaryPageLoaders = new Map();

export function registerSecondaryPage(name, importFn) {
  secondaryPageLoaders.set(name, importFn);
}

export function preloadSecondaryPages() {
  return Promise.allSettled(
    [...secondaryPageLoaders.values()].map((loadPage) => loadPage())
  );
}
